import { isBelowiOS26 } from '@/lib/utils/iosCompat'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { OverlayProvider } from '@gluestack-ui/core/overlay/creator'
import { ToastProvider } from '@gluestack-ui/core/toast/creator'
import { useTheme } from 'expo-router/react-navigation'
import { Stack, type NativeStackNavigationOptions } from 'expo-router'
import { Platform } from 'react-native'

export default function ProfileLayout() {
  const theme = useTheme()
  const [groupedBg] = usePlatformColor('systemGroupedBackgroundColor')

  return (
    <OverlayProvider>
      <ToastProvider>
        <Stack
          screenOptions={{
            title: '',
            headerLargeTitle: true,
            headerShadowVisible: false,
            headerBackButtonDisplayMode: 'minimal',
            contentStyle: {
              backgroundColor: Platform.OS === 'android' ? (groupedBg as string) : theme.colors.background,
            },
            ...Platform.select<NativeStackNavigationOptions>({
              ios: {
                headerTransparent: true,
                ...(isBelowiOS26 ? { headerBlurEffect: 'systemChromeMaterial' as const } : {}),
              },
              android: {
                headerTransparent: false,
                headerStyle: { backgroundColor: groupedBg as string },
              },
              web: {
                headerTransparent: false,
                headerStyle: { backgroundColor: groupedBg as string },
              },
            }),
          }}
        >
          <Stack.Screen name="index" options={{ title: '我的' }} />
        </Stack>
      </ToastProvider>
    </OverlayProvider>
  )
}
